import Dialog from '../components/passport/Dialog';
import Tost from '../components/Tost';
import SubmitSuccess from '../components/passport/SubmitSuccess';
import globalConfig from '../utiles/globalConfig';
import { SERVICE_TERM_URL, PRIVICY_TERM_URL } from '../utiles';
import bridge from '../utiles/bridge';
const search = globalConfig.getLocationSearch();
export default {
  data() {
    return {
      submitSuccess: false,
      showPopup: false,
      errTips: '',
      loadding: false,
    };
  },
  computed: {
    showDialog() {
      return this.$store.state.dialog.showDialog;
    },
    showTost() {
      return this.$store.state.dialog.tostShowStatus;
    },
    languages() {
      return this.$store.state.passport.languages;
    },
    accountLanguages() {
      return this.$store.getters.getAccountLanguages;
    },
    accountLang() {
      return this.$store.getters.getAccountLang;
    },
  },
  components: {
    Dialog,
    Tost,
    SubmitSuccessTips: SubmitSuccess,
  },
  methods: {
    reChange() {
      this.submitSuccess = false;
    },
    showErrorTips(errMsg) {
      this.showPopup = true;
      this.errTips = errMsg;
      this.$clearDisable();
    },
    selectTerm(terms) {
      this.terms = terms;
    },
    showLoadding() {
      this.loadding = true;
    },
    hideLoadding() {
      this.loadding = false;
    },
    showServiceTerms() {
      var href = 'https:' + SERVICE_TERM_URL + search; // + globalConfig.getLanguages() + ".html";
      bridge.callSdkMethod('openBrowser', {
        url: href,
        loginDir: 0,
        appendParams: 0,
      });
    },
    showPrivicyTerms() {
      var href = 'https:' + PRIVICY_TERM_URL + search; // + globalConfig.getLanguages() + ".html";
      bridge.callSdkMethod('openBrowser', {
        url: href,
        loginDir: 0,
        appendParams: 0,
      });
    },
  },
};
